import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as pujaServices from "../../services/puja.services";
import { GetAllAstrologer } from "../../services/psychic.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import CustomRangepicker from "../../common/rangepicker";
import { Modal, Button, Form } from "react-bootstrap"; // Import react-bootstrap
import $ from "jquery";

const PujaBookingsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [sorting, setSorting] = useState({});
  const [loader, setLoader] = useState(true);
  const [globalsearch, setGlobalSearch] = useState("");
  const [search, setSearch] = useState({});
  const [tab, setTab] = useState("all"); // all, requested, upcoming, in_progress, past
  const [resetdate, setResetDate] = useState(false);

  // For Assign Modal
  const [showModal, setShowModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [astrologers, setAstrologers] = useState([]);
  const [astroSearch, setAstroSearch] = useState("");
  const [astroLoader, setAstroLoader] = useState(false);

  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Puja Bookings", url: "" },
  ];

  const tabs = [
    { key: "all", label: "All" },
    { key: "requested", label: "Requested" },
    { key: "upcoming", label: "Upcoming" },
    { key: "in_progress", label: "In Progress" },
    { key: "past", label: "Past" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", page);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      formData.append("tab", tab);

      pujaServices.BookingList(formData)
        .then((res) => {
          setList(res.data.list || []);
          setDataLength(res.data.total_records || 0);
          setPage(res.data.page || 1);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(timer);
  }, [page, sorting, search, globalsearch, tab, resetdate]);

  // Fetch astrologers with debounce on search
  useEffect(() => {
    if (!showModal) return;

    const timer = setTimeout(() => {
      fetchAstrologers(astroSearch);
    }, 300);

    return () => clearTimeout(timer);
  }, [astroSearch, showModal]);

  const fetchAstrologers = (searchTerm = "") => {
    setAstroLoader(true);
    const formData = new FormData();
    formData.append("global_search", searchTerm); // API supports global_search on name

    GetAllAstrologer(formData)
      .then((res) => {
        setAstrologers(res.data.list || []); // Assuming response has list
        setAstroLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setAstroLoader(false);
      });
  };

  const handleSort = (column) => {
    let order = sorting.column === column && sorting.order === 1 ? -1 : 1;
    setSorting({ column, order });
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (value && value.length) sr[key] = value;
    else delete sr[key];
    setSearch(sr);
  };

  const resetFilter = () => {
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
  };

  const openAssignModal = (bookingId) => {
    setSelectedBookingId(bookingId);
    setAstroSearch("");
    fetchAstrologers(); // Initial fetch
    setShowModal(true);
  };

  const handleAssign = (astrologerId) => {
    if (!astrologerId) {
      Swal.fire("Error", "Please select an astrologer", "error");
      return;
    }

    pujaServices.AssignAstrologer({ puja_id: selectedBookingId, astrologer_id: astrologerId })
      .then(() => {
        Swal.fire("Success", "Astrologer assigned", "success");
        setShowModal(false);
        setResetDate(!resetdate);
      })
      .catch((err) => {
        Swal.fire("Error", err.message || "Assignment failed", "error");
      });
  };

  const updateStatus = (id, status) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        pujaServices.UpdateStatus({ puja_id: id, new_status: status })
          .then(() => {
            Swal.fire("Updated!", "", "success");
            setResetDate(!resetdate);
          })
          .catch((err) => {
            Swal.fire("Error", err.message || "Update failed", "error");
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Puja Bookings</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search..."
                    value={globalsearch}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
                <CustomRangepicker GetDateRange={(e) => prepareSearch("date_range", e)} resetdate={resetdate} />
                <button className="btn btn-warning ms-2" onClick={resetFilter}>Reset</button>
              </div>
            </div>

            {/* Tabs */}
            <ul className="nav nav-tabs mb-3">
              {tabs.map((t) => (
                <li key={t.key} className="nav-item">
                  <a
                    className={`nav-link ${tab === t.key ? "active" : ""}`}
                    onClick={() => { setTab(t.key); setPage(1); }}
                    style={{ cursor: "pointer" }}
                  >
                    {t.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="table-responsive">
              <table className="table table-bordered text-nowrap w-100">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>User</th>
                    <th>Puja Name</th>
                    <th>Occasion</th>
                    <th>Date & Time</th>
                    <th>Astrologer</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Payment</th>
                    <th className="action_head">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr><td colSpan="10"><Loader /></td></tr>
                  ) : list.length ? (
                    list.map((row, i) => (
                      <tr key={row.id}>
                        <td>{(page - 1) * itemperpage + i + 1}</td>
                        <td>{row.user_id?.name || "N/A"}</td>
                        <td>{row.puja_name}</td>
                        <td>{row.occasion || "-"}</td>
                        <td>
                          {new Date(row.scheduled_date).toLocaleDateString()} <br />
                          {row.schedule_time}
                        </td>
                        <td>{row.astrologer_id?.name || "-"}</td>
                        <td>₹{row.amount}</td>
                        <td>
                          <span className={`badge badge-${row.booking_status === "Completed" ? "success" : row.booking_status === "Cancelled" ? "danger" : "warning"}`}>
                            {row.booking_status}
                          </span>
                        </td>
                        <td>{row.payment_method} ({row.payment_status})</td>
                        <td>
                          {row.booking_status === "Requested" && (
                            <button className="btn btn-sm btn-info me-2" onClick={() => openAssignModal(row.id)}>
                              Assign
                            </button>
                          )}
                          {row.booking_status === "Confirmed" && (
                            <button className="btn btn-sm btn-primary me-2" onClick={() => updateStatus(row.id, "In Progress")}>
                              Start
                            </button>
                          )}
                          {row.booking_status === "In Progress" && (
                            <button className="btn btn-sm btn-success me-2" onClick={() => updateStatus(row.id, "Completed")}>
                              Complete
                            </button>
                          )}
                          {["Requested", "Confirmed", "In Progress"].includes(row.booking_status) && (
                            <button className="btn btn-sm btn-danger" onClick={() => updateStatus(row.id, "Cancelled")}>
                              Cancel
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="10" className="text-center">No records found</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-3">
              <b>Total Records: {datalength}</b>
            </div>

            {datalength > 0 && (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[{ name: "Puja Bookings", path: "/admin/puja-bookings" }]}
              />
            )}
          </div>
        </div>
      </div>

      {/* Assign Astrologer Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} style={{visibility: "visible",  pointerEvents: "initial"}}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Astrologer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Search Astrologer by Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name..."
              value={astroSearch}
              onChange={(e) => setAstroSearch(e.target.value)}
            />
          </Form.Group>

          {astroLoader ? (
            <Loader />
          ) : astrologers.length ? (
            <Form.Select id="astrologerSelect">
              <option value="">Select Astrologer</option>
              {astrologers.map((a) => (
                <option key={a.id} value={a.id}>
                  {a.name}
                </option>
              ))}
            </Form.Select>
          ) : (
            <p>No astrologers found</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => {
            const astroId = document.getElementById("astrologerSelect")?.value;
            handleAssign(astroId);
          }}>
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PujaBookingsList;